module.exports = {
  Individual: 'штука',
  AreYouWantToCopy: 'Подтвердите копирование?',
  Hint: 'Подсказка',
  Confirm: 'Подтвердить',
  Cancel: 'Отмена',
  BiDomainName: 'BI домен',
  FillBiDomainName: 'Укажите BI домен'
}
